import { useState, useEffect } from "react";

export default function useRole() {
  const [role, setRole] = useState();
  const [username, setUsername] = useState();
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    (async () => {
      const resp = await fetch('/api/role', {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json',
        },
      });
      const { role: role1, username: username1 } = await resp.json();
      setRole(role1);
      setUsername(username1);
      setIsLoaded(true);
    })();
  }, []);
  return [role, username, isLoaded];
}
